export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-dollar-30f37d1904b86e49527f56cd35cd8f1c.svg";